import { Outlet } from "react-router-dom";
import React from "react";

function Inquery() {
  return <Outlet />;
}

export default Inquery;
